import { makeStyles } from "@mui/styles"

import { Palette } from "@cirrus/ui-kit/src/lib/_private.js"

// @ts-ignore
export const useRadioClasses = makeStyles(({ withPalette, typography }) => ({
  // @ts-ignore
  checked: ({ color }) => ({
    "&.Mui-checked": {
      color: withPalette(color, Palette.isSecondary(color) ? "contrastText" : "main")
    }
  }),
  // @ts-ignore
  disabled: ({ checked, color }) => ({
    "&.Mui-disabled": {
      color: `${withPalette(!checked ? "main" : color ? color : "primary")} !important`
    }
  }),
  // @ts-ignore
  root: ({ checked, color }) => ({
    "& $svg": {
      color: withPalette(checked ? color : "inherit"),
      fontSize: typography.pxToRem(24)
    },
    color: "#757575"
  })
}))

// @ts-ignore
export const useFormControlLabelClasses = makeStyles(({ typography }) => ({
  label: {
    "&.MuiTypography-root": {
      color: typography.color,
      fontSize: typography.pxToRem(14),
      fontWeight: 700
    }
  },
  root: {
    "& > span:first-of-type": {
      padding: "8px"
    },
    marginBottom: 0,
    width: "fit-content",
  }
}))
